exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "ul.br_crumb-nav{list-style:none;font-size:12px;color:#7f8c8c}ul.br_crumb-nav li{display:inline}ul.br_crumb-nav li+li:before{padding:8px;color:#7f8c8c;content:\"/\\A0\"}ul.br_crumb-nav li a{color:#7f8c8c;text-decoration:none}ul.br_crumb-nav li a:hover{color:#5d6666;text-decoration:underline}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-bc932fde","scoped":false,"hasInlineConfig":true}!./src/components/breadcrumbs-navigation/breadcrumbs-navigation.css
// module id = ./node_modules/css-loader/index.js?minimize!./node_modules/vue-loader/lib/style-compiler/index.js?{"vue":true,"id":"data-v-bc932fde","scoped":false,"hasInlineConfig":true}!./src/components/breadcrumbs-navigation/breadcrumbs-navigation.css
// module chunks = index